import { getFromEnvVarsOrLocalStorage } from "./devFeatureFlags";

// prettier-ignore
export const featuredImageAltFormField = getFromEnvVarsOrLocalStorage("REACT_APP_FF_FEATURED_IMG_ALT");
export const isBookContentEnabled = getFromEnvVarsOrLocalStorage("REACT_APP_FF_BOOK_CONTENT");
export const areCoursesEnabled = getFromEnvVarsOrLocalStorage("REACT_APP_FF_COURSES");
export const verticalCourseThumbnailEnabled = getFromEnvVarsOrLocalStorage(
  "REACT_APP_FF_VERTICAL_COURSE_THUMBNAIL"
);
export const metabaseAnalyticsEnabled = getFromEnvVarsOrLocalStorage(
  "REACT_APP_FF_METABASE_ANALYTICS"
);
export const areDashboardQuotasEnabled = getFromEnvVarsOrLocalStorage(
  "REACT_APP_FF_DASHBOARD_QUOTAS"
);
export const areVideoAndAudioQuotasCombined = getFromEnvVarsOrLocalStorage(
  "REACT_APP_FF_AUDIO_VIDEO_QUOTAS_COMBINED"
);
